<template>
  <div class="anno-sidebar">
    <div id="upper">
      <tool-type-selector />
      <b-field label="Snap">
        <b-button @click="toggleSnap" type="is-info" expanded :inverted="!snap">
          {{ snapLabel }}
        </b-button>
        <!-- <b-switch v-model="snapFlag" type="is-info">{{ snapLabel }}</b-switch> -->
      </b-field>
      <b-field label="Label Overlay">
        <b-button
          type="is-info"
          expanded
          @click="toggleOverlay"
          :inverted="!overlayFlag"
        >
          {{ overlayLabel }}
        </b-button>
      </b-field>
      <b-field label="Alpha">
        <b-slider v-model="annotationAlpha" :min="0" :max="1" :step="0.1">
        </b-slider>
      </b-field>
      <settings-button type="is-fullwidth" />
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import ToolTypeSelector from "@/components/ToolTypeSelector";
import SettingsButton from "@/components/SettingsButton";
import ui from "@/store/modules/ui";

export default {
  name: "AnnotatorSidebar",
  components: {
    ToolTypeSelector,
    SettingsButton
  },
  setup() {
    // Snap: snap nodes vertically and horizontally
    const snapFlag = computed({
      get: () => ui.snap,
      set: val => {
        ui.setSnap(val);
      }
    });
    const annotationAlpha = computed({
      get: () => ui.annotationAlpha,
      set: val => {
        ui.setAnnotationAlpha(val);
      }
    });
    const snap = computed(() => ui.snap);
    const toggleSnap = () => {
      ui.setSnap(!snap.value);
    };
    const snapLabel = computed(() => (snapFlag.value ? "On" : "Off"));
    // Label overlay: show label names in the svg editor
    const overlayFlag = computed(() => ui.showLabelOverlay);
    const overlayLabel = computed(() => (overlayFlag.value ? "On" : "Off"));
    const toggleOverlay = () => {
      ui.setShowLabelOverlay(!overlayFlag.value);
    };

    return {
      snap,
      snapFlag,
      annotationAlpha,
      snapLabel,
      toggleSnap,
      overlayFlag,
      overlayLabel,
      toggleOverlay
    };
  }
};
</script>

<style lang="scss" scoped>
.anno-sidebar {
  height: 100%;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  // border-right: solid 2px hsl(0, 0%, 92%);
  box-shadow: 0 10px 10px $border-grey;
}

#upper {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.last-field {
  min-height: 0;
  display: flex;
  flex-direction: column;
}
</style>
